// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `auto-complete {
  color: black;
}
auto-complete .itemList {
  padding: 10px;
  margin-top: 8px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
  cursor: auto;
  background: rgba(255, 255, 255, 0.9647058824);
  height: 280px;
  font-family: Roboto;
}
auto-complete .itemList.noItems {
  height: auto;
}
auto-complete .itemScrollList {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow-y: scroll;
}
auto-complete .cdk-virtual-scroll-viewport {
  position: static;
}
auto-complete .cdk-virtual-scroll-orientation-vertical .cdk-virtual-scroll-content-wrapper {
  width: 100%;
}
auto-complete .item {
  cursor: pointer;
  /* position: aboslute; */
  border-bottom: 1px solid #ccc;
  padding: 6px;
  height: 70px;
  width: 100%;
  box-sizing: border-box;
}
auto-complete .item:hover {
  border-bottom: 1px solid rgb(141, 141, 141);
}
auto-complete .itemHighlight {
  background-color: rgba(188, 191, 201, 0.2);
  border-bottom: 1px solid #999;
}
auto-complete .item p {
  margin: 0px;
  padding: 0px;
  height: 1em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}
auto-complete .createItem {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  border-top: 1px solid rgb(207, 207, 207);
  cursor: pointer;
}
auto-complete .queryInput {
  cursor: pointer;
  border: 0px;
  background: none;
  display: inline-block;
  padding-left: 2px;
  min-width: 150px;
}
auto-complete .itemImage {
  width: 55px;
  height: 55px;
  float: right;
  max-width: 16%;
}
auto-complete .itemInfo {
  display: inline-block;
  vertical-align: top;
  margin: 0px;
  width: 84%;
}
auto-complete .itemInfo p {
  margin: 0px;
  margin-top: 2px;
  height: 2em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
auto-complete ::-webkit-scrollbar {
  width: 8px;
  z-index: 1;
  position: relative;
  background: rgb(241, 241, 241);
}
auto-complete ::-webkit-scrollbar-thumb {
  background: rgb(189, 189, 189);
}
auto-complete [contentEditable=true]:empty:not(:focus):before {
  content: attr(placeholder);
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/auto-complete/auto-complete/auto-complete.component.scss"],"names":[],"mappings":"AACA;EACI,YAAA;AAAJ;AAEI;EACI,aAAA;EACA,eAAA;EACA,sCAAA;EACA,YAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;AAAR;AAGI;EACI,YAAA;AADR;AAII;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AAFR;AAKI;EACI,gBAAA;AAHR;AAMI;EACI,WAAA;AAJR;AAOI;EACI,eAAA;EACA,wBAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;AALR;AAQI;EAEI,2CAAA;AAPR;AAUI;EACI,0CAAA;EACA,6BAAA;AARR;AAWI;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AATR;AAYI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,wCAAA;EACA,eAAA;AAVR;AAaI;EACI,eAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AAXR;AAcI;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AAZR;AAcI;EACI,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;AAZR;AAeI;EACI,WAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAbR;AAgBI;EACI,UAAA;EACA,UAAA;EACA,kBAAA;EACA,8BAAA;AAdR;AAgBI;EACI,8BAAA;AAdR;AAiBI;EACI,0BAAA;AAfR","sourcesContent":["\nauto-complete  {\n    color: black;\n\n    .itemList {\n        padding: 10px;\n        margin-top: 8px;\n        box-shadow: 0 0 8px rgba(0,0,0,.3);\n        cursor: auto;\n        background: #fffffff6;\n        height: 280px;\n        font-family: Roboto;\n    }\n\n    .itemList.noItems {\n        height: auto;\n    }\n\n    .itemScrollList {\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 100%;\n        box-sizing: border-box;\n        overflow-y: scroll;\n    }\n\n    .cdk-virtual-scroll-viewport {\n        position: static;\n    }\n\n    .cdk-virtual-scroll-orientation-vertical .cdk-virtual-scroll-content-wrapper {\n        width: 100%;\n    }\n\n    .item {\n        cursor: pointer;\n        /* position: aboslute; */\n        border-bottom: 1px solid #ccc;\n        padding: 6px;\n        height:70px;\n        width: 100%;\n        box-sizing: border-box;\n    }\n\n    .item:hover {\n        // background-color: rgba(188, 191, 201, 0.05);\n        border-bottom: 1px solid rgb(141, 141, 141);\n    }\n\n    .itemHighlight {\n        background-color: rgba(188, 191, 201, 0.2);\n        border-bottom: 1px solid #999;\n    }\n\n    .item p{\n        margin: 0px;\n        padding: 0px;\n        height: 1em;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        max-width: 100%;\n        display: block;\n    }\n\n    .createItem {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        box-sizing: border-box;\n        padding: 10px;\n        border-top: 1px solid rgb(207, 207, 207);\n        cursor: pointer;\n    }\n\n    .queryInput {\n        cursor: pointer;\n        border: 0px;\n        background: none;\n        display: inline-block;\n        padding-left: 2px;\n        min-width: 150px;\n    }\n\n    .itemImage {\n        width: 55px;\n        height: 55px;\n        float: right;\n        max-width:16%;\n    }\n    .itemInfo {\n        display: inline-block;\n        vertical-align: top;\n        margin: 0px;\n        width: 84%;\n    }\n\n    .itemInfo p {\n        margin: 0px;\n        margin-top: 2px;\n        height: 2em;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n    }\n\n    ::-webkit-scrollbar {\n        width: 8px;\n        z-index: 1;\n        position: relative;\n        background: rgb(241, 241, 241);\n    }\n    ::-webkit-scrollbar-thumb {\n        background: rgb(189, 189, 189);\n    }\n\n    [contentEditable=true]:empty:not(:focus):before{\n        content:attr(placeholder)\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
